<template>
	<div>
		<!-- Start Page Title -->
		<div class="page-title-area">
			<div class="d-table">
				<div class="d-table-cell">
					<div class="container">
						<h2>Administration Système Linux</h2>
					</div>
				</div>
			</div>

			<div class="shape1"><img src="../../../../assets/img/shape1.png" alt="IT+ formation cours informatique djibouti"></div>
			<div class="shape2 rotateme"><img src="../../../../assets/img/shape2.svg" alt="IT+ formation cours informatique djibouti"></div>
			<div class="shape3"><img src="../../../../assets/img/shape3.svg" alt="IT+ formation cours informatique djibouti"></div>
			<div class="shape4"><img src="../../../../assets/img/shape4.svg" alt="IT+ formation cours informatique djibouti"></div>
			<div class="shape5"><img src="../../../../assets/img/shape5.png" alt="IT+ formation cours informatique djibouti"></div>
			<div class="shape6 rotateme"><img src="../../../../assets/img/shape4.svg" alt="IT+ formation cours informatique djibouti"></div>
			<div class="shape7"><img src="../../../../assets/img/shape4.svg" alt="IT+ formation cours informatique djibouti"></div>
			<div class="shape8 rotateme"><img src="../../../../assets/img/shape2.svg" alt="IT+ formation cours informatique djibouti"></div>
		</div>
		<!-- End Page Title -->

		<!-- Start Services Details Area -->
		<section class="services-details-area ptb-80">
			<div class="container">
				<div class="row align-items-center">
					<div class="col-lg-6 services-details">
						<div class="services-details-desc">
							<h3>Linux Institue Professionnel</h3>
							<p>LIP (Linux Institue Professionnel) est une organisation à but non lucratif créé dans le
								but d’offrir à
								ceux qui le désirent des compétences en GNU/Linux. La LPIC est aujourd’hui la
								certification la
								plus demandée dans le monde de l’Open Source. Indépendante de toute distribution Linux,
								la
								certification LPI est devenue dans la pratique une certification incontournable pour qui
								veut évaluer
								ses compétences dans l’administration Linux.</p>
							<p>
								Cette formation est un cursus qui permet d’évaluer les aptitudes en gestion de système
								Linux.
								L’objectif de l’équipe IT+ est de vous procurer des compétences professionnelles plus
								approfondies,
								qui vous permettra de valider les connaissances exigées par la certification Comptia
								Linux+ et ainsi
								la réussir</p>


						</div>
					</div>

					<div class="col-lg-6 services-details-image">
						<img src="../../../../assets/img/courses/linux1.jpeg" class="wow fadeInUp" alt="IT+ Code Lab">
					</div>
				</div>

				<div class="separate"></div>

				<div class="row align-items-center">
					<div class="col-lg-6 services-details-image">
						<img src="../../../../assets/img/courses/centos.jpeg" class="wow fadeInUp" alt="IT+ Code Lab">
					</div>

					<div class="col-lg-6 services-details">
						<div class="services-details-desc">
							<p>À la fin de ce cours, vous serez capable de :</p>
							<ul>
								<li>d'nstaller et configurer l’interface graphique sous Linux ;</li>
								<li>
									d'installer et désinstaller les programmes sur les distributions des familles RedHat
									ou
									Debian, et gérer les bibliothèques partagées ;</li>
								<li>
									Gérer des systèmes de bases de Linux ;</li>
								<li>
									Connaître les bases de la ligne de commande (Bash, vi) ;</li>
								<li>
									Installer et paramétrer des applications sous Linux;</li>
								<li>Sauvegarder le système d'exploitation ;</li>
								<li>Administratrer de système de réseaux Linux ;</li>
								<li>Gérer les disques, partitions et systèmes de fichiers courants (y compris les
									quotas) ;</li>
								<li>Gérer des fichiers : permissions et propriétés, recherche et liens ;</li>
							</ul>

							<!--
							<div class="services-details-accordion">
								<VueFaqAccordion :items="myItems" />
							</div> -->
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- End Services Details Area -->

		<!-- <div class="container">

			<div class="row  justify-content-center ">


				<div class="col-lg-4 col-md-6 col-sm-6">
					<div class="pricing-table active-plan">
						<div class="pricing-header">
							<h3>Administration Système Linux</h3>
						</div>

						<div class="price">
							<span><sup>Fdj</sup>15000 <span>/Mois</span></span>
						</div>

						<div class="pricing-features">
							<ul>
								<li class="active">Durée de la formation : 3 mois</li>
								<li class="active">Matériels requis: Laptop core i3, 8GB RAM, 1TB Hard Disk</li>

							</ul>

						</div>
						<h6>Prérequis: </h6>
						<div class="pricing-features">

							<ul>
								<li class="active">Avoir une bonne expérience du système d’exploitation
									Microsoft Windows et des principes fondamentaux des réseaux</li>

							</ul>
						</div>


					</div>
				</div>

			</div>
		</div> -->
	</div>
</template>

<script setup>
useHead({
  title: "Formation Linux - IT+ CODE LAB",
  meta: [
    { name: "description", content: "Maîtrisez l'administration Linux et découvrez les bases des systèmes open-source avec notre formation pratique. | Code Lab | Cours et Formations en informatique à Djibouti" },
    { name: "keywords", content: "formation,linux,systèmes,cours,Djibouti" }
  ],
});
</script>
